export const SegmentedControl = ({ value, onChange, options = [] }) => (
  <div className="ds-seg" role="tablist">
    {options.map((opt) => (
      <button
        key={opt.value}
        type="button"
        role="tab"
        aria-current={opt.value === value ? "page" : undefined}
        className={opt.value === value ? "is-active" : undefined}
        onClick={() => onChange?.(opt.value)}
        disabled={opt.disabled}
        title={opt.title}
      >
        {opt.label}
        {opt.count != null && opt.count > 0 && <span className="ds-seg-count">{opt.count}</span>}
      </button>
    ))}
  </div>
)

export default SegmentedControl
